<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />

    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <error-log class="errLog-container right-menu-item"/> -->

        <!-- <el-tooltip content="通知" effect="dark" placement="bottom">
          <router-link to="/msgMan/:type" class='top-right-item'>
            <el-badge v-if="userMsgNum != 0" :value="userMsgNum" class="item">
              <i class='el-icon-bell'></i>
            </el-badge>
            <i v-else style="margin-top: 2px" class='el-icon-bell'></i>
          </router-link>
        </el-tooltip> -->

        <el-tooltip
          :content="$t('navbar.screenfull')"
          effect="dark"
          placement="bottom"
        >
          <screenfull class="screenfull right-menu-item" />
        </el-tooltip>

        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select class="international right-menu-item"/>
        </el-tooltip> -->

        <!-- <lang-select class="international right-menu-item"/> -->

        <!-- <el-tooltip :content="$t('navbar.theme')" effect="dark" placement="bottom">
          <theme-picker class="theme-switch right-menu-item"/>
        </el-tooltip> -->
      </template>

      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <span style="margin-right: 16px; float: left">{{ userName }}</span>

          <img
            style="float: left"
            src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
            class="user-avatar"
          />
          <i style="float: left" class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item style="width: 140px;">
              <span style="display:block;padding: 4px 10px;">首页</span>
            </el-dropdown-item>
          </router-link>

          <!-- <el-dropdown-item divided>
            <span style="display:block;padding: 4px 10px;" @click="logout">个人信息</span>
          </el-dropdown-item> -->

          <el-dropdown-item>
            <span style="display:block;padding: 4px 10px;" @click="showPwd"
              >修改密码</span
            >
          </el-dropdown-item>

          <el-dropdown-item divided>
            <span style="display:block;padding: 4px 10px;" @click="logout"
              >退出登录</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 修改密码 弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      title="修改密码"
      :visible.sync="pwdState"
      append-to-body
      width="600px"
      top="30px"
    >
      <el-form
        ref="pwdRef"
        :rules="pwdRules"
        :model="pwdData"
        label-position="right"
        label-width="120px"
        style="width: 470px"
      >
        <el-form-item label="原密码" prop="oldPwd">
          <el-input
            v-model="pwdData.oldPwd"
            placeholder="请输入原密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pwd">
          <el-input
            v-model="pwdData.pwd"
            placeholder="请输入新密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input
            v-model="pwdData.pwd2"
            placeholder="请输入确认密码"
            style="width: 300px"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdState = false" icon="el-icon-back"
          >取消</el-button
        >
        <el-button
          type="success"
          :loading="dialogLoading"
          @click="pwdSubFunc"
          icon="el-icon-check"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 通用
import Cookie from "js-cookie";

import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
// import SizeSelect from '@/components/SizeSelect'
import LangSelect from "@/components/LangSelect";
import ThemePicker from "@/components/ThemePicker";

// 接口
import { updatePwd } from "@/api/login";
import webSocketService from "@/utils/websocketService";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    // SizeSelect,
    LangSelect,
    ThemePicker
  },
  data() {
    return {
      userName: "",

      // 密码弹窗
      dialogLoading: false,
      pwdState: false,
      pwdData: {
        userId: "",
        oldPwd: "",
        pwd: "",
        pwd2: ""
      },
      pwdRules: {
        oldPwd: [{ required: true, message: "必填字段", trigger: "blur" }],
        pwd: [{ required: true, message: "必填字段", trigger: "blur" }],
        pwd2: [{ required: true, message: "必填字段", trigger: "blur" }]
      }
    };
  },
  computed: {
    ...mapGetters(["sidebar", "name", "avatar", "device"]),
    userMsgNum() {
      let userMsgNum = this.$store.getters.userMsgNum;
      if (!userMsgNum) {
        userMsgNum = Cookie.get("userMsgNum");
      }
      return userMsgNum;
    }
  },
  created() {
    this.$ELEMENT.size = "mini";
    this.$store.commit("SET_SIZE", "mini");

    let userInfo = JSON.parse(window.localStorage.userInfo);
    this.userName = userInfo.label;
    this.pwdData.userId = Cookie.get("userId");
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    // 显示弹窗
    showPwd() {
      this.pwdState = true;
    },
    // 修改密码
    pwdSubFunc() {
      this.$refs["pwdRef"].validate(valid => {
        if (valid) {
          let oldPwd = this.pwdData.oldPwd;
          let pwd = this.pwdData.pwd;
          let pwd2 = this.pwdData.pwd2;

          // 判断密码长度 6 - 15位
          const pwdReg = /^[a-zA-Z0-9_-]{6,15}$/;

          if (!pwdReg.test(pwd)) {
            this.$message({
              type: "warning",
              message: "请输入6至15位新密码，可包含字母、数字、下划线、减号"
            });
            return false;
          }
          // 两密码是否相等
          if (pwd != pwd2) {
            this.$message({
              type: "warning",
              message: "两次密码输入不一致，请重新输入"
            });
            return false;
          }
          this.dialogLoading = true;
          // 修改密码接口
          updatePwd(this.pwdData).then(res => {
            this.dialogLoading = false;

            let code = res.data.code;
            let msg = res.data.msg;
            if (code == "200") {
              this.pwdState = false;
              this.$nextTick(() => {
                this.$refs["pwdRef"].clearValidate();
              });
              this.$message.success("修改成功，请重新登录");
              Cookie.set("Token", "");
              this.$router.push("/login");
            } else {
              this.$message.error(msg);
            }
          });
        }
      });
    },
    // 退出登录
    logout() {
      // 关闭WebSocket连接
      webSocketService.closeWebSocket()
      Cookie.set("Token", "");
      Cookie.set("userId", "");
      Cookie.set("userName", "");
      this.$router.push({ path: "/login" });
      this.$store.commit("SET_ROUTERS", []);
      window.localStorage.userRoles = "";
      // store.getters.addRouters
      // this.$store.dispatch('LogOut').then(() => {
      //   location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      // })
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.top-right-item {
  margin-right: 16px;
  margin-top: 19px;
  float: left;
  font-size: 20px;
  color: #666;
  line-height: 20px;
  height: 20px;
}
</style>
